<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner">
                    <div class="tit-wrap mb-0">
                        <h2 class="tit">상품권 교환소</h2>
                        <div class="font-size-14 font-size-md-16 grey--text text--garken-3">
                            교환권번호를 입력하여 나누리 캐시로 교환하실 수 있습니다.
                        </div>
                    </div>
                    <v-divider class="my-6 my-lg-12" />

                    <v-row class="ma-n4">
                        <template v-for="item in items">
                            <v-col class="pa-4" cols="12" v-bind="{ lg }" :key="item.value">
                                <v-card elevation="0" style="overflow:visible" :to="`/exchange/${item.value.toLowerCase()}`" v-bind="{ disabled: item.disabled }">
                                    <v-hover v-slot="{ hover }">
                                        <v-responsive :aspect-ratio="3 / 2" style="overflow:visible">
                                            <v-card rounded="lg" class="fill-height" style="position: relative;">
                                                <v-card-text class="fill-height d-flex justify-center align-center px-4 py-0">
                                                    <v-img v-bind="{ ...item.image, contain: true }" />
                                                </v-card-text>
                                                <v-fade-transition>
                                                    <v-overlay v-show="hover" absolute color="primary" opacity="0.05" class="exchange-list-item-card__overlay">
                                                        <v-slide-x-transition>
                                                            <v-card v-show="hover" dark color="primary" elevation="0" class="rounded-b-lg">
                                                                <v-card-actions class="d-flex justify-end align-baseline py-3 px-6" style="gap:8px;">
                                                                    <span> 교환하기 </span>
                                                                    <v-icon small>mdi-arrow-right</v-icon>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-slide-x-transition>
                                                    </v-overlay>
                                                </v-fade-transition>
                                            </v-card>
                                        </v-responsive>
                                    </v-hover>
                                    <v-card-text class="px-0 text-center" v-if="!$vuetify.breakpoint.mobile">
                                        <b>{{ item.text }}</b
                                        >에서 받은 교환번호를 <br />
                                        나누리 상품권으로 교환하실 수 있습니다.
                                    </v-card-text>
                                    <v-overlay v-show="item.disabled" absolute light color="white" style="pointer-events:none">
                                        <span class="tit--sm font-weight-black black--text"> 준비중입니다. </span>
                                    </v-overlay>
                                </v-card>
                            </v-col>
                        </template>
                    </v-row>
                </div>
            </div>
        </v-container>
    </component>
</template>
<script>
import { USER_EXCHANGE_CODES } from "@/assets/lib";

const items = [
    {
        ...USER_EXCHANGE_CODES.AUCTION,
        image: { src: "/images/exchange/vendors/auction.svg" },
    },
    {
        ...USER_EXCHANGE_CODES.GMARKET,
        image: { src: "/images/exchange/vendors/gmarket.svg" },
    },
    {
        ...USER_EXCHANGE_CODES.SSG_COM,
        image: { src: "/images/exchange/vendors/ssg_com.svg" },
    },
    {
        ...USER_EXCHANGE_CODES.LOTTEON,
        image: { src: "/images/exchange/vendors/lotteon.svg" },
    },
    // {
    //     ...USER_EXCHANGE_CODES.TESTCODE,
    //     image: { src: "/images/logo.png" },
    // },
];
export default {
    components: {},
    data: () => ({
        items,
    }),
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        lg() {
            let lg = 12 % this.items.length;
            if (3 <= lg) return 12 / this.items.length;
            return 3;
        },
    },
};
</script>

<style lang="scss" scoped>
.contents-area {
    margin: -30px -24px;
    @media (min-width: 768px) {
        margin: -40px -24px;
    }
    @media (min-width: 1024px) {
        margin: 0;
        padding: 60px 114px;
    }
    &__inner {
        @media (max-width: 1023px) {
            padding: 20px 38px;
        }
    }
}

.exchange-list-item-card__overlay {
    position: absolute;
    bottom: 0;
    width: 100%;

    align-items: end;
    justify-content: stretch;

    &::v-deep .v-overlay__content {
        width: 100%;
    }
}
</style>
